import React from "react";
import dynamic from "next/dynamic";
import Seo from "src/components/shared/Seo";
import server from "src/api/server";
import { useRouter } from "next/router";
const BlogsComponent = dynamic(() => import("src/modules/Blogs/Index"));

const BlogsPage = ({
  data,
  appSetting = {},
  metaData = [],
  footerSettings,
}) => {
  const router = useRouter();
  const { locale } = router;

  const customMeta = [
    { name: "title", content: metaData?.[0]?.name?.[locale] },
    {
      name: "description",
      content: metaData?.[0]?.content?.[locale],
    },
  ];

  return (
    <>
      <Seo
        metaData={customMeta}
        appSetting={{
          ...appSetting,
          ...footerSettings,
        }}
        pageUrl={
          typeof window !== "undefined"
            ? window.location.href
            : `${process.env.NEXT_PUBLIC_SITE_URL}/${router.asPath}`
        }
      />
      <BlogsComponent data={data} />
    </>
  );
};

export async function getStaticProps() {
  const [
    blogsRes,
    questionsRes,
    indexRes,
    metaRes,
    footerRes,
  ] = await Promise.all([
    server.get("/api/blogs"),
    server.get("/api/posts/questions_blogs/all"),
    server.get("/api/index"),
    server.get("/api/metadataTags?type=blogs"),
    server.get("/api/footer"),
  ]);

  return {
    props: {
      data: {
        blogsData: blogsRes?.data?.data || null,
        questions: questionsRes?.data?.data || null,
      },
      metaData: metaRes?.data?.data?.metadata_tags || null,
      appSetting: indexRes?.data?.data?.AppSetting || null,
      footerSettings: footerRes?.data?.data || null,
    },
    revalidate: 10,
  };
}

export default BlogsPage;
